var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-text-field',_vm._g(_vm._b({attrs:{"rules":_vm.allRules}},'base-text-field',{ ..._vm.$attrs, ..._vm.$props },false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }